import { zLogRocket } from '@zoll/logrocket-react-lib'
import { disable, enable } from '@zoll/logrocket-base-lib/constants/toggleKeys'
import { isPlatformNative } from '../../utilities/platform.util'
import { getReleaseVersion } from '../../utilities/version.util'
import { customizeSanitizers } from './customizeSanitizers'

// ------------------------------------------------------------------------------
// Since the hybrid app is running in a WebView, it runs at location: http://localhost
// Therefore, we need to force the toggling on of Log Rocket since, by default,
// Log Rocket does not record sessions when running at localhost.
// See: https://zolldata.atlassian.net/wiki/spaces/DOCS/pages/216948113506/zLogRocket+Enable-Disable+and+QA
// ------------------------------------------------------------------------------
if (isPlatformNative()) {
  localStorage.removeItem(enable)
  localStorage.removeItem(disable)

  // Further gate so we can control session recordings via this environment variable:
  const enableLogRocket = `${process.env.REACT_APP_ENABLE_LOG_ROCKET}`

  if (enableLogRocket === 'true') {
    localStorage.setItem(enable, '1')
  }
}
// ------------------------------------------------------------------------------

zLogRocket.initialize({
  appId: 'zoll-data/emscharts-now',
  sanitizers: customizeSanitizers(),

  // optional/additional, LogRocket configuration options
  // @see https://docs.logrocket.com/reference/init
  options: {
    // The release version of this application.
    // @see https://docs.logrocket.com/reference/release
    release: getReleaseVersion('Version', 'Build'),

    // Disable Console Logging
    // We use the LogRocket logging mechanism (See src\services\logger.service.ts)
    console: {
      isEnabled: false,
    },
  },
})
